import { render } from "./TCMathGamePlay.vue?vue&type=template&id=639d5ccd&scoped=true"
import script from "./TCMathGamePlay.vue?vue&type=script&lang=js"
export * from "./TCMathGamePlay.vue?vue&type=script&lang=js"

import "./TCMathGamePlay.vue?vue&type=style&index=0&id=639d5ccd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tunescrib-rs/tunescrib-rs/dev.tunescrib.com-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639d5ccd"]])

export default __exports__